import { render, staticRenderFns } from "./EventPackageOfferTicketSectionsList.vue?vue&type=template&id=0606bb0c&"
import script from "./EventPackageOfferTicketSectionsList.vue?vue&type=script&lang=js&"
export * from "./EventPackageOfferTicketSectionsList.vue?vue&type=script&lang=js&"
import style0 from "./EventPackageOfferTicketSectionsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports